export interface Bill {
  id: string;
  date: string;
  type: string;
  site: string;
  groupCustomerID: string;
  groupCustomer: string;
  invoicedCustomerID: string;
  invoicedCustomer: string;
  payingCustomerID: string;
  payingCustomer: string;
  invoiceShipToAddresssID: string;
  dueDate: string;
  paymentTerms: string;
  taxRule: string;
  taxType: string;
  currency: string;
  amountTaxFree: number;
  amountIncludingTax: number;
  status: string;
  isInvoiceOpen: boolean;
  remainingAmountWithTax: number;
  openItems: {
    dueDate: string;
    payingCustomerID: string;
    amount: number;
    paymentAmount: number;
    remainingAmount: number;
  }[];
}

export interface OpenItems {
  dueDate: string;
  payingCustomerID: string;
  amount: number;
  paymentAmount: number;
  remainingAmount: number;
}

export interface BillSearchResponse {
  id: string;
  number: string;
  customerId: string;
  date: string;
  dueDate: string;
  type: string;
  amountTaxFree: number | null;
  amountIncludingTax: number;
  // Indicateur de paiement : true = non payée, false = payée
  isInvoiceOpen: boolean | null;
  remainingAmountWithTax: number;
  openItems: OpenItems[];
}

export type ReclamationBill = Pick<Bill, 'id'>;

export enum BillCategory {
  BILL = 'facture',
  CREDIT = 'avoir',
}
